// extracted by css-extract-rspack-plugin
export default {"clinicNotesSection":"clinicNotesSection-FjbRkt","clinicNotesField":"clinicNotesField-ceL9PG"};